import React from 'react';
import config from '../config/config';
import { isIOS, isAndroid } from '../utils/detectDevice';

const APP_URLS = config.urls;
const VIEW_IN_APP_LABEL = 'アプリで見る';
const VIEW_IN_APP_DEFAULT_ZOOM = 15;

/**
 * モバイル画面左下の「アプリで見る」コンポーネント
 */
const ViewInApp = ({
  mapConfig
}) => {

  const handleViewInAppClick = () => {
    try {
      if (!mapConfig) {
        return;
      }

      // 地図座標とズームレベルを取得
      const center = mapConfig.center;
      if (!center) {
        return;
      }

      const lat = Number(center.lat);
      // 念のためlonにも対応
      const lng = Number(center.lng ?? center.lon);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        return;
      }

      const zoom = Number(mapConfig.zoom);
      const zoomNum = Number.isFinite(zoom) ? Math.round(zoom) : VIEW_IN_APP_DEFAULT_ZOOM;

      if (isIOS()) {
        const scl = Math.min(zoomNum, VIEW_IN_APP_DEFAULT_ZOOM);

        // iOS Universal Link を組み立て
        const url = new URL(APP_URLS.viewInApp.iosUniversalLinkBase);
        url.searchParams.set('lat', String(lat));
        url.searchParams.set('lon', String(lng));
        url.searchParams.set('scl', String(scl));
        url.searchParams.set('dtm', 'wgs');

        window.location.href = url.toString();
        return;
      }

      if (isAndroid()) {
        // Android intent URL を組み立て（schemeは "mapionapp" のようなスキーム名）
        const hostAndPath = APP_URLS.viewInApp.androidIntentHostAndPath;
        const scheme = APP_URLS.viewInApp.androidIntentScheme;
        const pkg = APP_URLS.viewInApp.androidPackage;

        const query = `lat=${encodeURIComponent(String(lat))}&lng=${encodeURIComponent(String(lng))}&z=${encodeURIComponent(String(zoomNum))}`;
        const intentUrl = `intent://${hostAndPath}?${query}#Intent;scheme=${scheme};package=${pkg};end`;

        window.location.href = intentUrl;
        return;
      }
      // iOS/Android以外は何もしない(例:判定漏れ、その他モバイルOS、PC等)
      return;
    } catch (error) {
    }
  };

  return (
    // モバイル端末で表示制御する項目についてはmap-controls.cssで指定(max-width: 768px）
    <div className="view-in-app-container">

      {/* アプリで見るボタン */}
      <button
        id="view-in-app-btn"
        className="view-in-app-btn"
        onClick={handleViewInAppClick}
      >
        <span>{VIEW_IN_APP_LABEL}</span>
      </button>

    </div>
  );
};

export default ViewInApp;